<template>
  <div class="ui-interaction-btns-wrapper">
    <div class="btn-wrapper" v-for="item in interactionBtns" :key="`interaction_btn_${item.btnText}`" @click="handleClick(item)">
      <img :src="item.icon" class="btn-icon" />
      <span class="label">{{ item.btnText }}</span>
      <span class="count">{{ item.count }}</span>
    </div>
  </div>
</template>

<script>
import nfpluslogin from "@/mixins/nfplusLogin"
import { buryingPoint } from "@/server/interfaces"

export default {
  name: "uiInteractionBtns",
  props: {
    interactionBtns: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mixins: [nfpluslogin],
  methods: {
    async handleClick(item) {
      const hasUserInfo = await this.nfplusLogin()
      hasUserInfo && this.$emit("click", item)
      const actionType = item.actionType
      this[`_buryingPointClick_${actionType}`]()
    },
    _buryingPointClick_giveFlower() {
      buryingPoint({
        params: {
          action: 8
        }
      })
    },
    _buryingPointClick_bow() {
      buryingPoint({
        params: {
          action: 9
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-interaction-btns-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  .btn-wrapper {
    width: 1.86rem;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 1.2rem;
    font-family: PingFang-SC-Bold;
    font-size: 0.26rem;
    font-weight: bold;
    &:active {
      opacity: 0.7;
    }
    .label {
      white-space: nowrap;
    }
    .btn-icon {
      width: 100%;
      height: 1.7rem;
      margin-bottom: 0.2rem;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.ui-interaction-btns-wrapper.pc {
  padding-top: 54px;
  line-height: 26px;
  .btn-wrapper {
    width: 149px;
    margin-right: 209px;
    font-family: PingFang-SC-Bold;
    font-size: 20px;
    font-weight: bold;
    &:last-child {
      margin-right: 0;
    }
    .btn-icon {
      height: 136px;
      margin-bottom: 10px;
    }
  }
}
</style>
